import React from 'react';
import Link from 'next/link';
import { getResultTypeText } from '@common/header/messageModal/messages/companyMessage/resultRequest/resultModals';
import Modal from '@common/modal';
import Icon from '@common/assets';
import { MatchingTalkApplyType } from '@domain/rs/match/message/MatchingMessageListRs';
import Colors from '@domain/constant/colors';
import { AccaRouteUrl, RouteUrl } from '@utils/routeUtil';
import classnames from 'classnames/bind';
import styles from './matchResultSelectModal.module.scss';
const cx = classnames.bind(styles);

interface EmptyMatchResultSelectModalProps {
  isVisible: boolean;
  onClose: () => void;
  applyType: MatchingTalkApplyType | null;
}

const EmptyMatchResultSelectModal = ({ isVisible, onClose, applyType }: EmptyMatchResultSelectModalProps) => {
  const emptyModalText = `${getResultTypeText(applyType)} 결과가 없습니다.`;

  const moveTo = () => {
    const url = (() => {
      switch (applyType) {
        case 'ACC':
          return RouteUrl.ACCA_TEST_GATE;
        case 'PACC':
        case 'PST':
          return RouteUrl.PHS_TEST_GATE;
        default:
          return '/';
      }
    })();

    return `${url}?source_page=MATCH`;
  };

  if (applyType !== 'ACC')
    return (
      <Modal visible={isVisible} dimmed={true} isUseScrollHidden={false}>
        <div className={cx('layer')}>
          <strong className={cx('title')}>잡다매칭에 사용할 결과표를 선택해 주세요.</strong>
          <div className={cx('paccEmptyArea')}>
            <div className={cx('emptyInner')}>
              <strong className={cx('emptyTitle')}>{emptyModalText}</strong>

              <Link href={moveTo()} legacyBehavior>
                <a className={cx('link')} target="_blank" role="button">
                  응시하러 가기
                </a>
              </Link>
            </div>
          </div>
          <div className={cx('btnArea')}>
            <button className={cx('btn')} type="button" disabled={true}>
              선택 완료
            </button>
          </div>

          <a className={cx('btnClose')} role="button" onClick={onClose}>
            <span className={cx('hidden')}>close</span>
          </a>
        </div>
      </Modal>
    );

  return (
    <Modal visible={isVisible} dimmed={true} isUseScrollHidden={false}>
      <div className={cx('emptyArea')}>
        <div className={cx('textArea')}>
          <em className={cx('title')}>아직 역량검사 응시 전이에요.</em>
          <div className={cx('desc')}>
            <span>딱! 한 번만 응시해도 취업이 쉬워져요.</span>
            <span className={cx('linkWrap')}>
              <Link href={AccaRouteUrl.ACCA_INTRODUCE} legacyBehavior>
                <a className={cx('link')}>
                  더 알아보기
                  <Icon name="arrowRightLight" width={24} height={24} fill={Colors.C_BLUE_100} />
                </a>
              </Link>
            </span>
          </div>
        </div>
        <div className={cx('img')} />

        <Link href={AccaRouteUrl.ACCA_TEST_GATE} legacyBehavior>
          <a className={cx('btn')}>역검 응시하기</a>
        </Link>

        <a className={cx('btnClose')} role="button" onClick={onClose}>
          <span className={cx('hidden')}>close</span>
        </a>
      </div>
    </Modal>
  );
};

export default EmptyMatchResultSelectModal;
